import enhanceTopicALevelFurtherColumns from './aLevelFurtherTopicTable';
import enhanceTopicALevelColumns from './aLevelTopicTable';
import enhanceGcseTopicColumns from './gcseTopicTable';

export const columnEnhancers = {
  DatoCmsEdexcelALevelTopic: enhanceTopicALevelColumns,
  DatoCmsEdexcelALevelFurtherTopic: enhanceTopicALevelFurtherColumns,
  DatoCmsEdexcelGcseTopic: enhanceGcseTopicColumns,
};
